import { Component, OnDestroy, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../core/services/authfake.service';
import { environment } from '../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { AttendanceService } from '../../core/services/attendance.service';
import { CheckInRequest } from '../../core/models/attendance/checkin-request.model';
import { CheckOutRequest } from '../../core/models/attendance/checkout-request.model';
import { User } from 'src/app/core/models/auth.models';
import { EntityService } from 'src/app/core/services/entity.service';
import { SMRSEntity } from 'src/app/core/Interface/IEntity';
import { AllowedIP } from 'src/app/core/Interface/allowedIP';

interface AttendanceState {
  startedAt: string;
  userKey: string;
}

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})

/**
 * Topbar component
 */
export class TopbarComponent implements OnInit, OnDestroy {

  private readonly attendanceStorageKey = 'smrs-attendance-state';
  private attendanceTimerId: number | null = null;
  private attendanceStartedAt: string | null = null;
  private currentUser: User;
  private ipAddress: string = '';
  private arrayOfAllowedIPs: AllowedIP[] = [];

  element;
  cookieValue;
  flagvalue;
  countryName;
  valueset;

  constructor(@Inject(DOCUMENT) private document: any, private router: Router,
              private authService: AuthenticationService,
              private authFackservice: AuthfakeauthenticationService,
              private attendanceService: AttendanceService,
              public languageService: LanguageService,
              public translate: TranslateService,
              public _cookiesService: CookieService,
              public entityService:EntityService
              ) {
  }

  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
    { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
    { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  ];

  openMobileMenu: boolean;

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();
  _userName: string='';
  isEmployee = false;
  isCheckedIn = false;

  isAttendanceSubmitting = false;
  attendanceElapsedTime = '00:00:00';
  ngOnInit() {
    this.currentUser = this.authService.loggedInUser();
    this._userName = this.currentUser ? this.currentUser.username : '';
    this.isEmployee = !!(this.currentUser && this.currentUser.groupcode != 'admin');
    
    this.myIpAddress();
    this.getSettings();
    this.openMobileMenu = false;
    this.element = this.document.documentElement;

    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.jpg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }
    
    this.restoreAttendanceState();
   /*if(this.authService.currentUser() !=null){
      var userData: string[]=[];
       userData = this.authService.currentUser();
       this._userName = userData["name"];
    }
    */

  }
  getSettings(){
   
  this.entityService.getAllowedIPByClient(this.currentUser.tenant_id).subscribe(res => {
    this.arrayOfAllowedIPs = res;
    console.log(res);   
  });
}
myIpAddress(){
  this.attendanceService.getIPAddress().subscribe(res => {
  this.ipAddress = res.ip;
  
});

}
  ngOnDestroy() {
    this.stopAttendanceTimer();
  }

  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  handleAttendanceAction() {
    if (this.isAttendanceSubmitting) {
      return;
    }

    if (this.isCheckedIn) {
      this.checkOut();
      return;
    }

    this.checkIn();
  }

  /**
   * Logout the user
   */
  logout() {
    this.isCheckedIn = false;
    this.clearAttendanceState();
    this.stopAttendanceTimer();
    this.attendanceStartedAt = null;
    this.attendanceElapsedTime = '00:00:00';

    if (environment.defaultauth === 'firebase') {
      this.authService.logout();
    } else {
      this.authFackservice.logout();
    }
    this.router.navigate(['/account/login']);
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  private async checkIn() {
    const userId = this.getAttendanceUserId();
    if (!userId) {
      Swal.fire('Unable to check in', 'Logged-in employee id is not available.', 'warning');
      return;
    }

    this.isAttendanceSubmitting = true;

    try {
      const location = await this.attendanceService.getCurrentLocation();
      const request: CheckInRequest = {
        userId,
        latitude: Number(location.latitude),
        longitude: Number(location.longitude),
        officeLatitude: Number(this.arrayOfAllowedIPs[0].officelatitude),
        officeLongitude: Number(this.arrayOfAllowedIPs[0].officelongitude),

        accuracy: Number(location.accuracy),
        deviceInfo: this.ipAddress ? `IP: ${this.ipAddress}` : 'Location data'
      };

      this.attendanceService.checkIn(request).subscribe({
        next: () => {
          const startedAt = new Date().toISOString();
          this.isCheckedIn = true;
          this.persistAttendanceState(startedAt);
          this.startAttendanceTimer(startedAt);
          this.isAttendanceSubmitting = false;
          Swal.fire('Checked In', 'Your attendance has been marked successfully.', 'success');
        },
        error: () => {
          this.isAttendanceSubmitting = false;
          Swal.fire('Check-in failed', 'Unable to mark attendance right now.', 'error');
        }
      });
    } catch (error) {
      this.isAttendanceSubmitting = false;
      Swal.fire('Location unavailable', this.getLocationErrorMessage(error), 'warning');
    }
  }

  private async checkOut() {
    const userId = this.getAttendanceUserId();
    if (!userId) {
      Swal.fire('Unable to check out', 'Logged-in employee id is not available.', 'warning');
      return;
    }

    this.isAttendanceSubmitting = true;

    try {
      const location = await this.attendanceService.getCurrentLocation();
      const request: CheckOutRequest = {
        userId,
        latitude: Number(location.latitude),
        longitude: Number(location.longitude)
      };

      this.attendanceService.checkOut(request).subscribe({
        next: () => {
          this.isCheckedIn = false;
          this.clearAttendanceState();
          this.stopAttendanceTimer();
          this.attendanceStartedAt = null;
          this.attendanceElapsedTime = '00:00:00';
          this.isAttendanceSubmitting = false;
          Swal.fire('Checked Out', 'Your check-out has been completed successfully.', 'success');
        },
        error: () => {
          this.isAttendanceSubmitting = false;
          Swal.fire('Check-out failed', 'Unable to complete check-out right now.', 'error');
        }
      });
    } catch (error) {
      this.isAttendanceSubmitting = false;
      Swal.fire('Location unavailable', this.getLocationErrorMessage(error), 'warning');
    }
  }

  private getAttendanceUserId(): number | null {
    const user = this.currentUser ;
    //const possibleKeys = ['id', 'userId', 'user_id', 'employeeId', 'employee_id', 'Id', 'UserId', 'EmployeeId'];

    // for (let i = 0; i < possibleKeys.length; i++) {
    //   const value = user ? Number(user[possibleKeys[i]]) : NaN;
    //   if (!isNaN(value) && isFinite(value) && value > 0) {
    //     return value;
    //   }
    // }

    return user.id;
  }

  private getAttendanceUserKey(): string {
    const user = this.currentUser ;
    return String(user.usercode || user.username || this.getAttendanceUserId() || '');
  }

  private restoreAttendanceState() {
    if (!this.isEmployee) {
      return;
    }

    const savedState = sessionStorage.getItem(this.attendanceStorageKey);
    if (!savedState) {
      return;
    }

    try {
      const parsedState = JSON.parse(savedState) as AttendanceState;
      if (!parsedState || !parsedState.startedAt || parsedState.userKey !== this.getAttendanceUserKey()) {
        this.clearAttendanceState();
        return;
      }

      this.isCheckedIn = true;
      this.startAttendanceTimer(parsedState.startedAt);
    } catch (error) {
      this.clearAttendanceState();
    }
  }

  private persistAttendanceState(startedAt: string) {
    const state: AttendanceState = {
      startedAt,
      userKey: this.getAttendanceUserKey()
    };

    sessionStorage.setItem(this.attendanceStorageKey, JSON.stringify(state));
  }

  private clearAttendanceState() {
    sessionStorage.removeItem(this.attendanceStorageKey);
  }

  private startAttendanceTimer(startedAt: string) {
    this.attendanceStartedAt = startedAt;
    this.updateAttendanceElapsedTime();
    this.stopAttendanceTimer();
    this.attendanceTimerId = window.setInterval(() => {
      this.updateAttendanceElapsedTime();
    }, 1000);
  }

  private stopAttendanceTimer() {
    if (this.attendanceTimerId !== null) {
      window.clearInterval(this.attendanceTimerId);
      this.attendanceTimerId = null;
    }
  }

  private updateAttendanceElapsedTime() {
    if (!this.attendanceStartedAt) {
      this.attendanceElapsedTime = '00:00:00';
      return;
    }

    const elapsedMilliseconds = Math.max(Date.now() - new Date(this.attendanceStartedAt).getTime(), 0);
    const totalSeconds = Math.floor(elapsedMilliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    this.attendanceElapsedTime = [hours, minutes, seconds]
      .map(value => value.toString().padStart(2, '0'))
      .join(':');
  }

  private getLocationErrorMessage(error: any): string {
    if (error && error.message) {
      return error.message;
    }

    return 'Please allow location access to continue.';
  }
}
